module.exports = __webpack_public_path__ + "img/护理-7.df9be1d2.png";